export default __webpack_public_path__ + "static/media/image.pencil-store.ce3dc863.png";